import React, { FC, useEffect, useLayoutEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { MenuNoticeFull, MenuNoticeScroll, QueueBar, ShopwindowAdvert, SoldoutBar } from '../..'
import ProductTemplate from '../ProductTemplate'
import { Advert as MenuAdvert } from '@cps'
import { RESTAURANT_EVENT, menuMobx, restaurantCenter, storeMobx } from 'restaurant'
import WaitingProduct from '../WaitingProduct'
import { useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react'
import { useHistoryNew } from '@utils'
import './index.scss'

let saveStoreId = 0
let advertTimer = null
/** 菜单主体内容  */
const MenuContent: FC = () => {
  const [fullNotice, setFullNotice] = useState(false)
  /** ionic 轮播有bug，切换门店，先隐藏 */
  const [hideAdvert, setHideAdvert] = useState(true)

  const history = useHistoryNew()

  const loadingAdvert = () => {
    /** 门店切换，但是非菜单页，不需要显示 */
    clearTimeout(advertTimer)
    if (saveStoreId !== storeMobx.info.storeId) {
      setHideAdvert(true)
      saveStoreId = storeMobx.info.storeId
      advertTimer = setTimeout(() => {
        setHideAdvert(false)
      }, 1000)
    } else {
      setHideAdvert(false)
    }
  }

  useEffect(() => {
    const event = restaurantCenter.on(RESTAURANT_EVENT.STORE_CHANGED, ({ type }) => {
      if (history.getRouteInfo().pathname === '/menu') {
        loadingAdvert()
      }
    })
    return () => {
      restaurantCenter.off(event)
    }
  }, [])
  useIonViewWillEnter(() => {
    loadingAdvert()
  })
  /** 其他页面也会切换门店，需要先隐藏广告 */
  useIonViewDidLeave(() => {
    setHideAdvert(true)
  })
  useEffect(() => {
    loadingAdvert()
  }, [])

  return (
    <div className='menu-style-big-content-container'>
      <QueueBar />
      {menuMobx.canOpenSoldout && menuMobx.openSoldoutHidden === 1 && menuMobx.openSoldout === 1 && <SoldoutBar />}
      {fullNotice && <MenuNoticeFull onChange={(full) => setFullNotice(full)} />}
      {!fullNotice && <MenuNoticeScroll type='waterfall' onChange={(full) => setFullNotice(full)} />}
      <WaitingProduct />
      {!hideAdvert && <MenuAdvert wrapWidth={window.innerWidth * 0.956 - 74} type='menu' />}
      <ShopwindowAdvert useType='waterfall' />
      <ProductTemplate />
    </div>
  )
}

export default observer(MenuContent)
